<template>
  <t-form label-width="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题大小">
        <t-input-number size="small" v-model="attribute.title.textStyle.fontSize" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.title.textStyle.color"/>
      </t-form-item>
      <!--      <t-form-item label="副标题">
              <t-input size="small" v-model="attribute.title.subtext"/>
            </t-form-item>
            <t-form-item label="副标题颜色">
              <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.title.subtextStyle.color"/>
            </t-form-item>-->
      <t-form-item label="标题位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="标题位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="图例" :expand="false">
      <t-form-item label="图例显示">
        <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="图例位置(X)">
        <e-chart-position v-model="attribute.legend.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="图例位置(Y)">
        <e-chart-position v-model="attribute.legend.top" :direction="'y'"/>
      </t-form-item>
      <t-form-item label="图例布局方式">
        <t-radio-group v-model="attribute.legend.orient" size="small">
          <t-radio-button value="vertical">纵向</t-radio-button>
          <t-radio-button value="horizontal">横向</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="图例字体">
        <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="图例文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="内边距" :expand="false">
      <t-form-item label="内边距(左)">
        <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(上)">
        <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(右)">
        <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(下)">
        <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="x轴" :expand="true">
      <t-form-item label="x轴">
        <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <div v-show="attribute.xAxis.show">
        <t-form-item label="x轴指示文字">
          <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40"/>
        </t-form-item>
        <t-form-item label="x轴线显示">
          <t-switch v-model="attribute.xAxis.axisLine.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="x轴线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color" size="small"/>
        </t-form-item>
        <t-form-item label="x轴刻度线">
          <t-switch v-model="attribute.xAxis.axisTick.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="x轴字体颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color" size="small"/>
        </t-form-item>
        <t-form-item label="x轴字号">
          <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="x轴字体倾斜">
          <t-input-number v-model="attribute.xAxis.axisLabel.rotate" :min="-180" :max="180" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="x轴网格线">
          <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small"/>
        </t-form-item>
      </div>
    </e-collapse>
    <e-collapse title="y轴" :expand="false">
      <t-form-item label="y轴">
        <t-switch v-model="attribute.yAxis.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <div v-show="attribute.yAxis.show">
        <t-form-item label="y轴指示文字">
          <t-input v-model="attribute.yAxis.name" size="small" :maxcharacter="40"/>
        </t-form-item>
        <t-form-item label="y轴线显示">
          <t-switch v-model="attribute.yAxis.axisLine.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="y轴颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLine.lineStyle.color" size="small"/>
        </t-form-item>
        <t-form-item label="y轴网格线">
          <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="y轴刻度线">
          <t-switch v-model="attribute.yAxis.axisTick.show"  :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="y轴字体颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLabel.color" size="small"/>
        </t-form-item>
        <t-form-item label="y轴字号">
          <t-input-number v-model="attribute.yAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
        </t-form-item>
      </div>
    </e-collapse>
    <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
      <t-switch v-model="attribute.dataZoom.show"/> 
    </t-form-item>
    <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
     <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
    </t-form-item>
  </t-form>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import CptData from '@/components/element/options/comp/cpt-data';
export default {
  name: "cpt-chart-candlestick-option",
  components: {EChartPosition,CptData},
  props: {
      attribute: Object,
      cptDataForm:Object,
  },
}
</script>

<style scoped>

</style>
